export default "__VITE_ASSET__BvW$zKBN__"